import { render, staticRenderFns } from "./related-prompts-analytics.view.vue?vue&type=template&id=a170d890&scoped=true"
import script from "./related-prompts-analytics.view.vue?vue&type=script&lang=ts"
export * from "./related-prompts-analytics.view.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-analytics.view.vue?vue&type=style&index=0&id=a170d890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a170d890",
  null
  
)

export default component.exports